export default "__VITE_ASSET__DiwR50Bg__"